export function getReferrerMarket() {
  return localStorage.getItem('referrer_market');
}

export function setReferrerMarket(market: string | null) {
  if (market) {
    localStorage.setItem('referrer_market', market);
  }
}

// Set the time at which a refresh offer request was made for this seller input id
// Time is passed in as milliseconds from unix epoch time.
export function setRefreshOfferCalledAt(sellerInputId: string, refreshOfferCalledAt: number) {
  const dt = refreshOfferCalledAt.toString();
  localStorage.setItem(`${sellerInputId}-refresh-offer-called-at`, dt);
}

// Returns the time the offer refresh was called in milliseconds from unix epoch.
export function getRefreshOfferCalledAt(sellerInputId: string): number | null {
  const dt = localStorage.getItem(`${sellerInputId}-refresh-offer-called-at`);
  if (!dt) {
    return null;
  }
  return parseInt(dt, 10);
}

export function deleteRefreshOfferCalledAt(sellerInputId: string) {
  localStorage.removeItem(`${sellerInputId}-refresh-offer-called-at`);
}
